<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {

  created() {
    document.title = '银信互动'
  }
}
</script>
<style lang="less">

</style>
